module.exports = __webpack_public_path__ + "media/flags/nl-340f4109.svg";